import { render, staticRenderFns } from "./ProfilePictureUpload.vue?vue&type=template&id=1b32ca68&scoped=true&"
import script from "./ProfilePictureUpload.vue?vue&type=script&lang=js&"
export * from "./ProfilePictureUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePictureUpload.vue?vue&type=style&index=0&id=1b32ca68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32ca68",
  null
  
)

component.options.__file = "ProfilePictureUpload.vue"
export default component.exports